export default "__VITE_ASSET__DGFJ$Q1T__"